"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { drawerVariants } from "./Drawer.variants.js";
const { close: DrawerClose_close } = drawerVariants();
const DrawerClose_DrawerClose = /*#__PURE__*/ forwardRef(function({ className, buttonClassName, slots, 'aria-label': ariaLabel, ...props }, ref) {
    return /*#__PURE__*/ jsx(Drawer.Close, {
        ref: ref,
        "aria-label": ariaLabel ?? 'Close drawer',
        className: cn(DrawerClose_close(), className, buttonClassName, slots?.close),
        ...props
    });
});
export { DrawerClose_DrawerClose as DrawerClose };
